import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from 'src/app/shared/services/users.service';

@Component({
  selector: 'app-assessment2',
  templateUrl: './assessment2.component.html',
  styleUrls: ['./assessment2.component.css']
})
export class Assessment2Component implements OnInit {
  data = {
    module : "Assessment 2"
  }

  constructor(
    private usersService : UsersService,
    private router: Router
  ) { 
    
  }

  ngOnInit(): void {
  }

  async completed() {
    
    let courseCompleted = {
      assessment2: this.data.module
    }
    await this.usersService.userProgress(courseCompleted);
   
    this.router.navigate(['/solar-power-design']);
  }

}
